var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"News"},[_c('PageBanner',{attrs:{"bannerObj":_vm.bannerObj}}),_c('div',{staticClass:"contain"},[_c('ComDetails',{attrs:{"infoColumn":"1","baseUrl":"announcement"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }